import { Component, inject, OnInit, signal } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import {
  FormFactoryComponent,
  FormFactoryService,
} from 'ngx-dynamic-forms-factory';
import { Subscription } from 'rxjs';
import {
  AuthService,
  AutoUnsubscribe,
  LoadingToastService,
  ToastService,
} from 'libs/core/src/public-api';
import { ButtonComponent } from 'libs/ui/src/public-api';
import { LoginFieldsService } from '../../services/login-fields.service';

@Component({
  selector: 'lib-set-password',
  imports: [FormFactoryComponent, TranslateModule, ButtonComponent],
  templateUrl: './set-password.component.html',
})
@AutoUnsubscribe('subs')
export class SetPasswordComponent implements OnInit {
  authService = inject(AuthService);
  fieldsService = inject(LoginFieldsService);
  private formFactory = inject(FormFactoryService);
  private toastService = inject(ToastService);
  private loadingToastService = inject(LoadingToastService);
  private router = inject(Router);

  form!: FormGroup;
  isSaving = signal(false);
  subs = new Subscription();

  ngOnInit(): void {
    this.form = this.formFactory.createForm(
      this.fieldsService.setPasswordFields,
    );

    this.subs.add(
      this.form.get('password')?.valueChanges.subscribe(() => {
        this.form.get('password_confirmation')?.updateValueAndValidity();
      }),
    );
  }

  onSubmit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.isSaving.set(true);
    this.form.disable();
    this.loadingToastService.showLoadingToast();

    this.subs.add(
      this.authService.setPassword(this.form.getRawValue()).subscribe({
        next: (res) => {
          this.loadingToastService.clearLoadingToast();
          this.toastService.addSuccess({ detail: res.message });
          this.authService.removeUserData();
          this.router.navigate(['/auth/login']);
        },
        error: (err) => {
          this.loadingToastService.clearLoadingToast();
          this.toastService.addError({ detail: err.error.message });
          this.form.enable();
          this.isSaving.set(false);
        },
      }),
    );
  }

  onSignOut() {
    this.authService.logout();
  }
}
